import { deleteShipmentActivity, postBookingDriverAssignment, postCreateShipmentActivty } from '@dc-trans/data-layer';
import type { ApiResponse, BookingAssignDriverPayload, ShipmentActivityPayload } from '@dc-trans/data-layer';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { mergeApiErrorNotificationMeta, type MutationOptionsWithNotification } from '@/mutations/utils';

type AssignmentVariables = {
  id: string;
  payload: BookingAssignDriverPayload;
};

type ShipmentActivityVariables = {
  id: string;
  payload: ShipmentActivityPayload;
};

type DeleteShipmentVariables = {
  bookingId: string;
  ids: string[];
};

export const usePostBookingDriverAssignment = (
  options?: MutationOptionsWithNotification<ApiResponse<any>, AxiosError<ApiResponse<any>>, AssignmentVariables>
) => {
  const { disableErrorNotification, meta, ...restOptions } = options ?? {};
  const mergedMeta = mergeApiErrorNotificationMeta(
    {
      message: 'Gagal menyimpan penugasan driver.',
    },
    meta,
    disableErrorNotification
  );

  return useMutation<ApiResponse<any>, AxiosError<ApiResponse<any>>, AssignmentVariables>({
    ...restOptions,
    mutationFn: args => postBookingDriverAssignment(args.id, args.payload),
    meta: mergedMeta,
  });
};

export const usePostCreateShipmentActivity = (
  options?: MutationOptionsWithNotification<ApiResponse<any>, AxiosError<ApiResponse<any>>, ShipmentActivityVariables>
) => {
  const { disableErrorNotification, meta, ...restOptions } = options ?? {};
  const mergedMeta = mergeApiErrorNotificationMeta(
    {
      message: 'Gagal menyimpan aktivitas pengiriman.',
    },
    meta,
    disableErrorNotification
  );

  return useMutation<ApiResponse<any>, AxiosError<ApiResponse<any>>, ShipmentActivityVariables>({
    ...restOptions,
    mutationFn: args => postCreateShipmentActivty(args.id, args.payload),
    meta: mergedMeta,
  });
};

export const useDeleteShipmentActivity = (
  options?: MutationOptionsWithNotification<ApiResponse<any>, AxiosError<ApiResponse<any>>, DeleteShipmentVariables>
) => {
  const { disableErrorNotification, meta, ...restOptions } = options ?? {};
  const mergedMeta = mergeApiErrorNotificationMeta(
    {
      message: 'Gagal menghapus aktivitas pengiriman.',
    },
    meta,
    disableErrorNotification
  );

  return useMutation<ApiResponse<any>, AxiosError<ApiResponse<any>>, DeleteShipmentVariables>({
    ...restOptions,
    mutationFn: args => deleteShipmentActivity(args.bookingId, args.ids),
    meta: mergedMeta,
  });
};
